//@flow
import React from 'react';

import {
  // FormControlLabel,
  IconButton,
  makeStyles,
  TableCell,
} from '@material-ui/core';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
// import IosSwitch from '../../../../../../elements/IosSwitch/IosSwitch';
import {Edit} from '@material-ui/icons';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';
import {useState} from 'react';

import SimilarProductsModal from './SimilarProductsModal';
import {useResetRelatedProducts} from '../../../../../products/utils/hooks';
import {useProductContext} from '../../../../context';
import {useEditProduct} from '../../../../utils/editProduct';
import {useDebounceEffect} from '../../../../../../utils/react';
import {useRef} from 'react';

const useStyles = makeStyles(theme => ({
  similarProducts: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  textField: {
    width: '240px',

    '& input': {
      cursor: 'pointer',
    },
  },
}));

const getCriteriaLabel = {
  PRODUCT_CATEGORY: {
    singular: 'Categoría',
    plural: 'Categorías',
  },
  PRODUCT: {
    singular: 'Producto',
    plural: 'Productos',
  },
  PRODUCT_SUB_CATEGORY: {
    singular: 'Subcategoría',
    plural: 'Subcategorías',
  },
};

export default function SimilarProductsCell() {
  const classes = useStyles();

  const firstRender = useRef(true);

  const [productId] = useProductContext(product => product.id);
  const [relatedProducts] = useProductContext(
    product => product.relatedProductSetting
  );
  const {editProduct} = useEditProduct(productId);

  const resetRelatedProducts = useResetRelatedProducts();

  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  const closeModal = () => {
    setModalOpen(false);
    resetRelatedProducts();
  };

  const [enabled] = useState(true);

  useDebounceEffect(
    () => {
      if (firstRender.current) {
        firstRender.current = false;
        return;
      }
      editProduct({
        relatedProductSetting: {
          enabled,
        },
      });
    },
    750,
    [enabled]
  );
  /* 
  const toggleEnabled = () => {
    setEnabled(!enabled);
  };
 */
  const getLabel = () => {
    if (!relatedProducts) return '';

    const criteria = relatedProducts.relatedProductCriteria;

    const criteriaLabel = getCriteriaLabel[criteria];

    let count = relatedProducts.relatedProductsCount;

    if (criteria === 'PRODUCT_CATEGORY') {
      count = relatedProducts.relatedCategoryProductsCount;
    }

    if (criteria === 'PRODUCT_SUB_CATEGORY') {
      count = relatedProducts.relatedSubCategoryProductsCount;
    }

    const label = `${count} ${
      count === 1 ? criteriaLabel.singular : criteriaLabel.plural
    } ${count === 1 ? 'relacionado' : 'relacionados'}`;

    return label;
  };
  return (
    <>
      <TableCell align="right">
        <div className={classes.similarProducts}>
          {/* <FormControlLabel
            control={
              <IosSwitch
                checked={enabled}
                value={enabled}
                onChange={toggleEnabled}
              />
            }
            label="Activado"
            labelPlacement="start"
          /> */}
          <CustomTextField
            name="features"
            className={classes.textField}
            defaultValue={getLabel()}
            type="text"
            placeholder="Productos/Categorías relacionadas"
            // disabled={!enabled}
            onFocus={() => {
              window.document.activeElement.blur();
              openModal();
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  edge="end"
                  onClick={openModal} /* disabled={!enabled} */
                >
                  <Edit />
                </IconButton>
              ),
            }}
          />
        </div>
      </TableCell>
      <CustomModal open={modalOpen} handleCloseModal={closeModal}>
        {modalOpen && <SimilarProductsModal onSubmit={closeModal} />}
      </CustomModal>
    </>
  );
}
